<template>
  <div class="flex flex-col gap-6 p-6" v-if="pageEnabled">
    <nav class="pb-3" aria-label="Breadcrumb">
      <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-400">
              <span v-html="$icons.home"></span>

              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li v-for="(item, i) in breadcrumb" :key="i">
          <div class="flex items-center">
            <span class="text-gray-400" v-html="$icons.chevron_right"></span>

            <router-link
              :to="item.url"
              class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
              >{{ item.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>
    <header-component @save-params="save" :isRunning="isRunning" />
    <div class="text-ontick-yellow-900 flex items-center gap-2 pt-6" v-if="isRunning">
      <i>
        <svg
          data-v-9f0632ec=""
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
        >
          <path
            data-v-9f0632ec=""
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      </i>
      <p>Esta operação está ativa. Não é possível editar os parâmetros</p>
    </div>
    <params-section-component class="pt-6" :editInfo="editInfo" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ontickBreadcrumbComponent from "../../../shared/components/basic/ontick-breadcrumb.component.vue";
import HeaderComponent from "../components/header.component.vue";
import ParamsSectionComponent from "../components/params-section.component.vue";

export default {
  components: {
    ontickBreadcrumbComponent,
    HeaderComponent,
    ParamsSectionComponent,
  },

  data() {
    return {
      editInfo: {},
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      getData: "longShort/getData",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
    breadcrumb() {
      return [
        {
          name: "Long & Short",
          url: { name: "Long & Short" },
        },
        {
          name: `${this.$route.name === "Editar ordem Long & Short" ? "Editar" : "Criar"} ordem`,
          url: { name: this.$route.name },
        },
      ];
    },

    method() {
      switch (this.getData.method) {
        case "Fator":
          return "FACTOR";
        case "Diferença":
          return "DIFFERENCE";
        case "Função linear":
          return "LINEAR_FUNCTION";
        default:
          return "";
      }
    },

    exitRuleAlert() {
      return !this.getData.endDate && this.getData.advancedParams && !this.getData.TPFactor && !this.getData.SLFactor;
    },

    isRunning() {
      if (this.getData.orderState) {
        return !["NEW", "FILLED", "STOPPED"].includes(this.getData.orderState);
      }
      return false;
    },

    isEditing() {
      return this.$route.name === "Editar ordem Long & Short";
    },
  },

  methods: {
    ...mapActions({
      clearData: "longShort/clearData",
      setData: "longShort/setData",
      checkSingleSymbol: "longShort/checkSingleSymbol",
      getConfigs: "config/getConfigs",
    }),
    pageEnabled() {
      return this.getConfigs.side_menus.map((item) => item.menu_name).includes("Long & Short");
    },
    disableEditing(state) {
      return !["NEW", "FILLED", "STOPPED"].includes(state);
    },
    makeid(length) {
      let result = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    },
    save() {
      if (this.exitRuleAlert) {
        this.$swal({
          title: "Alerta",
          text: "Você não definiu nenhuma regra de saída. Deseja continuar?",
          icon: "warning",
          showDenyButton: true,
          denyButtonText: "Não",
          confirmButtonText: "Sim",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            if (this.isEditing) {
              this.updateOrder();
            } else {
              this.createAlgoOrder();
            }
          }
        });
      } else {
        if (this.isEditing) {
          this.updateOrder();
        } else {
          this.createAlgoOrder();
        }
      }
    },
    createAlgoOrder() {
      this.$api
        .post(this.$endpoint.CREATE_ALGO_ORDER, {
          alg_ord_name: this.getData.orderName,
          alg_ord_description: this.getData.orderDescription,
          visibility: "PRIVATE",
          account_id: this.getSelectedAccount.account_id,
          algorithm: "LONG_SHORT",
          direction: this.getData.operationType === "Compra" ? "BUY" : "SELL",
          goal: "ENTRY",
          symbol_1: this.getData.symbol1,
          symbol_2: this.getData.symbol2,
          start_datetime: this.getData.startDate || undefined,
          end_datetime: this.getData.endDate || undefined,
          calc_type: this.method,
          entry_value: this.getData.entryFactor || undefined,
          tp_value: this.getData.TPFactor || undefined,
          sl_value: this.getData.SLFactor || undefined,
          volume_type: this.getData.volumeType,
          volume:
            (this.getData.volumeType === "FIN_VOLUME" &&
              Number(this.getData.symbol1FinVolume.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."))) ||
            undefined,
          volume_1: (this.getData.volumeType === "QUANTITY" && this.getData.symbol1QtdVolume) || undefined,
          volume_2: (this.getData.volumeType === "QUANTITY" && this.getData.symbol2QtdVolume) || undefined,
          sender: "malacarne",
          comment: this.getData.operationType === "Compra" ? "Compra para entrada" : "Venda para entrada",

          intercept_value: (this.getData.method === "Função linear" && this.getData.intercept) || undefined,
          slope_value: (this.getData.method === "Função linear" && this.getData.slope) || undefined,
          tp_sl_calc_type: this.getData.tp_sl_calc_type === "percent" ? "PERCENT" : undefined,
        })
        .then(({ data }) => {
          // console.log(data);
          this.$swal("Sucesso", `Ordem (ID: ${data.alg_ord_id}) adicionada`, "success").then(() => {
            this.$router.push({ name: "Long & Short" });
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },

    updateOrder() {
      this.$api
        .post(this.$endpoint.UPDATE_ALGO_ORDER, {
          account_id: this.getSelectedAccount.account_id,
          alg_ord_id: this.$route.params.alg_ord_id,

          alg_ord_name: this.getData.orderName,
          alg_ord_description: this.getData.orderDescription,

          entry_value: this.getData.entryFactor || undefined,
          intercept_value: (this.getData.method === "Função linear" && this.getData.intercept) || undefined,
          slope_value: (this.getData.method === "Função linear" && this.getData.slope) || undefined,

          tp_value: this.getData.TPFactor || undefined,
          sl_value: this.getData.SLFactor || undefined,

          volume:
            (this.getData.volumeType === "FIN_VOLUME" &&
              Number(this.getData.symbol1FinVolume.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."))) ||
            undefined,
          volume_1: (this.getData.volumeType === "QUANTITY" && this.getData.symbol1QtdVolume) || undefined,
          volume_2: (this.getData.volumeType === "QUANTITY" && this.getData.symbol2QtdVolume) || undefined,

          start_datetime: this.getData.startDate || undefined,
          end_datetime: this.getData.endDate || undefined,
        })
        .then(({ data }) => {
          // console.log(data);
          this.$swal("Sucesso", `Ordem (ID: ${this.$route.params.alg_ord_id}) editada`, "success").then(() => {
            this.$router.push({ name: "Long & Short" });
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },

    getOrderInfo() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.GET_ALGO_ORDER_DETAILS, {
            params: {
              alg_ord_id: this.$route.params.alg_ord_id,
              account_id: this.getSelectedAccount.account_id,
            },
          })
          .then((res) => {
            // console.log(res);
            resolve(res.data);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
  },

  watch: {
    "getData.symbol1": {
      handler(val) {
        if (val.length >= 5) {
          this.checkSingleSymbol({ symbol_number: 1, symbol_name: val });
        }
      },
    },
    "getData.symbol2": {
      handler(val) {
        if (val.length >= 5) {
          this.checkSingleSymbol({ symbol_number: 2, symbol_name: val });
        }
      },
    },
  },

  mounted() {
    if (this.$route.params.alg_ord_id) {
      this.isLoading = true;
      this.getOrderInfo()
        .then((res) => {
          this.editInfo = res;

          this.setData({
            prop: "orderName",
            value: res.alg_ord_name,
          });
          this.setData({
            prop: "orderDescription",
            value: res.alg_ord_description,
          });
          this.setData({
            prop: "orderState",
            value: res.alg_ord_state,
          });

          if (!!res.alg_ord_code) {
            this.setData({
              prop: "isPublicOrder",
              value: true,
            });
            this.setData({
              prop: "editDisabled",
              value: true,
            });
          } else {
            this.setData({
              prop: "isPublicOrder",
              value: false,
            });
            this.setData({
              prop: "editDisabled",
              value: false,
            });
          }

          this.setData({
            prop: "volumeType",
            value: res.alg_ord_volume_type,
          });
          this.setData({
            prop: "symbol1",
            value: res.alg_ord_symbol_1,
          });
          switch (res.alg_ord_volume_type) {
            case "FIN_VOLUME":
              this.setData({
                prop: "symbol1FinVolume",
                value: res.alg_ord_volume_1,
              });
              break;
            case "QUANTITY":
              this.setData({
                prop: "symbol1QtdVolume",
                value: res.alg_ord_volume_1,
              });
              break;
          }
          this.setData({
            prop: "symbol2",
            value: res.alg_ord_symbol_2,
          });
          switch (res.alg_ord_volume_type) {
            case "FIN_VOLUME":
              this.setData({
                prop: "symbol2FinVolume",
                value: res.alg_ord_volume_2,
              });
              break;
            case "QUANTITY":
              this.setData({
                prop: "symbol2QtdVolume",
                value: res.alg_ord_volume_2,
              });
              break;
          }
          this.setData({
            prop: "operationType",
            value: res.alg_ord_direction,
          });
          if (res.alg_ord_start_datetime) {
            // console.log(res.alg_ord_start_datetime);
            this.setData({
              prop: "startDate",
              value: res.alg_ord_start_datetime,
            });
          }
          if (res.alg_ord_end_datetime) {
            this.setData({
              prop: "endDate",
              value: res.alg_ord_end_datetime,
            });
          }
          this.setData({
            prop: "method",
            value: (() => {
              switch (res.alg_ord_calc_type) {
                case "FACTOR":
                  return "Fator";
                case "DIFFERENCE":
                  return "Diferença";
                case "LINEAR_FUNCTION":
                  return "Função linear";
                default:
                  return res.alg_ord_calc_type;
              }
            })(),
          });
          this.setData({
            prop: "entryFactor",
            value: res.alg_ord_entry,
          });
          this.setData({
            prop: "currentFactor",
            value: res.curr_entry,
          });
          if (res.alg_ord_tp) {
            this.setData({
              prop: "advancedParams",
              value: true,
            });
            this.setData({
              prop: "TPFactor",
              value: res.alg_ord_tp,
            });
          }
          if (res.alg_ord_sl) {
            this.setData({
              prop: "advancedParams",
              value: true,
            });
            this.setData({
              prop: "SLFactor",
              value: res.alg_ord_sl,
            });
          }
          this.setData({
            prop: "tp_sl_calc_type",
            value: (() => {
              if (res.tp_sl_calc_type !== "PERCENT") {
                return "factor";
              }
              return "percent";
            })(),
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.setData({ prop: "orderName", value: `L&S ${this.makeid(6)}` });
      this.setData({ prop: "orderDescription", value: `Ordem Long & Short` });
    }
  },

  destroyed() {
    this.clearData();
  },
};
</script>

<style></style>
